import GatsbyImageWrapper from '../../GatsbyImageWrapper';
import React from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

type SearchListProductProps = {
    product: any;
};

export function SearchListProduct(props: SearchListProductProps) {
    const { product } = props;

    const { currentLocale, navigateTranslated } = usePageLocalization();

    const handleClick = () => {
        const isDiscontinued =
            product?.slug?.['en_CA']?.includes('discontinued');

        if (!isDiscontinued) {
            navigateTranslated(product?.slug?.[currentLocale]);
        } else {
            navigateTranslated(
                `/archives/${product?.code?.toLowerCase()}/parts`
            );
        }
    };

    return (
        <div className='product' onClick={handleClick}>
            <div className='image'>
                <GatsbyImageWrapper
                    className='product-img-wrapper'
                    imgStyle={{ objectFit: 'contain' }}
                    fields={product?.fields}
                />
            </div>
            <div className='info'>
                {product?.code}
                <br />
                <b>{`${product?.title?.[currentLocale]}`}</b>
            </div>
        </div>
    );
}
